module.exports = __webpack_public_path__ + "static/media/280804.ee787409.png";